import React from "react";
import PropTypes from "prop-types";
import Icon from "components/common_components/Icon";

function MediaMessage({ hasFailed, url, type, onClick }) {
    const handleOnClick = () => {
        onClick(url, type);
    };

    return (
        <div className={`media${!url ? " placeholder" : ""}`}>
            {!url && !hasFailed && <div>loading...</div>}

            {hasFailed && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Icon name="crime" size="sm" />
                    <p>Failed to load media</p>
                </div>
            )}

            {!hasFailed && url && (
                <div className="media_icon">
                    <div style={{ zIndex: 123, position: "absolute" }}>
                        <Icon name="home" size="sm" />
                    </div>
                    {String(type).startsWith("image") && (
                        <div className="picture_preview" style={{ backgroundImage: `url(${url})`, zIndex: 122 }} onClick={handleOnClick} />
                    )}
                    {String(type).startsWith("video") && (
                        <video controls>
                            <source src={url} type={type} />
                            Your browser does not support the video tag.
                        </video>
                    )}
                </div>
            )}
        </div>
    );
}

MediaMessage.propTypes = {
    hasFailed: PropTypes.bool.isRequired,
    url: PropTypes.string,
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default MediaMessage;
